import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Platform } from '@egovsolutions/angular-platform';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-confirm-dependencies-inclussion',
    template: `
        <egov-dialog-close-button></egov-dialog-close-button>
        <div class="dialog-content" [class.firefox]="platform.isFirefox">
            <p class="prevent-overlap-with-close-button">
                <ng-container *ngIf="!alternativeText; else altText">
                    In order to add {{ triggerItemName }} to the cart, the following items also need to be added:
                </ng-container>
                <ng-template #altText>{{ altText }}</ng-template>
            </p>
            <ul>
                <li *ngFor="let name of additionalItemsNames">{{ name }}</li>
            </ul>
        </div>
        <mat-dialog-actions>
            <button class="text-only-button" [mat-dialog-close]="false">Cancel</button>
            <button class="default text-only-button" [mat-dialog-close]="true">OK</button>
        </mat-dialog-actions>
    `,
    styleUrls: ['./confirm-dependencies-inclussion.component.scss']
})
export class ConfirmDependenciesInclussionComponent implements ConfirmDependenciesDialogOptions
{
    constructor
    (
        // Template dependencies

        protected platform: Platform,


        // Passed values

        @Inject(MAT_DIALOG_DATA) options: ConfirmDependenciesDialogOptions,
    )
    {
        Object.assign(this, options);
    }

    public triggerItemName!: string;
    public additionalItemsNames!: string[];
    public alternativeText?: string;
}

export interface ConfirmDependenciesDialogOptions
{
    triggerItemName: string
    additionalItemsNames: string[]
    alternativeText?: string
}
